import { indicatorTypes, isSubchartIndicator } from '../utils/drawUtils/indicatorTypes';

const MARGIN = { top: 16, right: 56, bottom: 28, left: 12 };
const PRICE_HEIGHT = 360;
const VOLUME_GAP = 8;
const SUBPANE_HEIGHT = 110;
const SUBPANE_GAP = 1; // just enough for a 1px divider

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

/**
 * Computes every panel's height/offset synchronously from props alone --
 * no DOM measurement round-trip, so container height never snaps/flashes
 * when indicators are toggled (the old implementation measured post-render
 * then corrected via a setTimeout(...,100)).
 */
export function computeLayout({ width, selectedIndicators = [] }) {
  const availableWidth = Math.max(0, width - MARGIN.left - MARGIN.right);

  const subpanes = (selectedIndicators || [])
    .filter((label) => isSubchartIndicator(label))
    .map((label) => ({
      id: label,
      type: indicatorTypes[label],
      height: SUBPANE_HEIGHT,
    }));

  const priceHeight = PRICE_HEIGHT;
  const volumeHeight = clamp(priceHeight * 0.16, 60, 100);

  const priceTop = 0;
  const volumeTop = priceTop + priceHeight + VOLUME_GAP;
  const subpanesTop = volumeTop + volumeHeight + VOLUME_GAP;

  let cursor = subpanesTop;
  const positionedSubpanes = subpanes.map((pane, i) => {
    const top = cursor;
    cursor += pane.height + (i < subpanes.length - 1 ? SUBPANE_GAP : 0);
    return { ...pane, top };
  });

  const contentHeight = subpanes.length > 0 ? cursor : volumeTop + volumeHeight;
  const totalHeight = MARGIN.top + contentHeight + MARGIN.bottom;

  return {
    margin: MARGIN,
    availableWidth,
    totalHeight,
    price: { top: priceTop, height: priceHeight },
    volume: { top: volumeTop, height: volumeHeight },
    subpanes: positionedSubpanes,
  };
}
